module.exports = __webpack_public_path__ + "img/img_workspace_guide_banner.7d9eb0f2.png";